module.exports = __webpack_public_path__ + "static/img/activity_sdy_02-3.322e470.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_02-3.jpg
// module id = PGpK
// module chunks = 0